import {FaChevronDown, FaChevronLeft, FaChevronUp, FaSearch} from 'react-icons/fa';
import "./SupportLookup.scss";
import {useState} from 'react';
import supportLookupWebService from '../../services/webService/SearchSupportRequest';
import dayjs from 'dayjs';

const SupportLookup = () => {
    const [searchValue, setSearchValue] = useState(""); // Quản lý giá trị tìm kiếm
    const [activeItem, setActiveItem] = useState(null); // Quản lý trạng thái của mục đang được mở
    const [data, setData] = useState({}); // Quản lý dữ liệu tìm kiếm
    const [errorMessage, setErrorMessage] = useState(""); // Lưu lỗi

    const handleShow = (index) => {

        setActiveItem(activeItem === index ? null : index); // Đóng nếu nhấn lại, mở nếu nhấn mới
    };

    const handleSearch = async () => {
        if (!searchValue.trim()) {
            setErrorMessage("Vui lòng nhập số điện thoại");
            return;
        }

        const phoneRegex = /^(0|\+84)(\d{9})$/;
        if (!phoneRegex.test(searchValue)) {
            setErrorMessage("Số điện thoại không hợp lệ");
            setData({});
            return;
        }

        setErrorMessage("");

        try {
            const data = await supportLookupWebService.searchSupportRequest({mobile: searchValue});
            if (data) {
                setData(data);
            }
        } catch (error) {
            console.error("Lỗi khi tìm kiếm:", error);
        }
    }
    return (
        <div className="section-top" style={{position: "relative"}}>
            <div className="container" style={{height: "100vh"}}>
                <div className='d-flex align-items-center gap-2'>
                    <FaChevronLeft/>
                    <h4>
                        Tra cứu yêu cầu hỗ trợ
                    </h4>

                </div>
                <div style={{maxWidth: 600, margin: "auto"}} className='mt-5'>
                    <div>
                        <div className='d-flex gap-3'>
                            <div className={"w-100"}>
                                <div className='input-search'>
                                    <FaSearch/>
                                    <input
                                        type="text"
                                        onChange={(e) => {
                                            setSearchValue(e.target.value);
                                            if (errorMessage) setErrorMessage("");
                                        }}
                                        placeholder="Nhập số điện thoại"
                                    />

                                </div>
                                <p className={"message-error"}>
                                    {errorMessage}
                                </p>
                            </div>

                            <button className='button-link' onClick={handleSearch}>Tìm</button>
                        </div>
                        <div>
                            {data?.data?.length > 0 && <div className='input-search-data'>
                                <div className='ipd-header'>
                                    <div>Ghi nhận : <span style={{color: "#2366ED"}}>{data?.total_records} yêu cầu tra soát</span>
                                    </div>
                                </div>
                                <div className='ipd-content'>
                                    {data?.data?.map((item, index) => {
                                        return (
                                            <div className='ipd-items'>
                                                <div className="ipd-item">
                                                    <div className="ipd-item-header">
                                                        <div style={{color: "#58595B", minWidth: "90px"}}>Nội dung:
                                                        </div>
                                                        <div>{item?.content}</div>
                                                    </div>
                                                    <div
                                                        className={`ipd-item-content ${activeItem === index && "show"}`}>
                                                        <div className="d-flex mt-3">
                                                            <div className="step">
                                                                <div className={`circle`}>{1}</div>
                                                                {<div
                                                                    className={`process ${item?.status === 1 ? "on" : ""}`}></div>}
                                                            </div>
                                                            <div className="step-content">
                                                                <div>Gửi yêu cầu</div>
                                                                <p>{dayjs(item?.created_at).format("DD/MM/YYYY")}</p>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex mt-3">
                                                            <div className="step">
                                                                <div
                                                                    className={`circle ${item?.status === 1 ? "on" : ""}`}>{2}</div>
                                                                <div
                                                                    className={`process ${(item?.status === 1 || item?.status === 2 || item?.time_finished === null) ? "on" : ""}`}></div>
                                                            </div>
                                                            <div className="step-content">
                                                                <div>HPAY tiếp nhận yêu cầu</div>
                                                                <p>{item?.time_process && dayjs(item?.time_process).format("DD/MM/YYYY")}</p>
                                                                <p style={{color: "#3A3B3C"}}>{item?.status === 2 && item?.reply}</p>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex my-3">
                                                            <div className="step">
                                                                <div
                                                                    className={`circle ${item?.status === 3 && item?.time_finished !== null ? "" : "on"}`}>{3}</div>
                                                            </div>
                                                            <div className="step-content">
                                                                <div>HPAY xử lý yêu cầu</div>
                                                                <p>{item?.time_finished && dayjs(item?.time_finished).format("DD/MM/YYYY")}</p>
                                                                <p style={{color: "#3A3B3C"}}>{item?.status === 3 && item?.time_finished !== null && item?.reply}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mt-3 d-flex justify-content-center">
                                                        <button className="btn-open" onClick={() => handleShow(index)}>
                                                            Xem thông tin
                                                            {activeItem === index ? <FaChevronUp/> : <FaChevronDown/>}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SupportLookup